"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('random-error-generator');
// can be used to simulate random network and tracking errors
class RandomErrorGenerator {
    constructor(errors, options) {
        this.errors = errors;
        this.options = options;
        this.state = { phase: 'no-error' };
        if (errors.length === 0) {
            throw new Error('Minimum one error need to be provided.');
        }
    }
    generate() {
        if (this.state.phase === 'no-error') {
            const rand = Math.random();
            if (rand <= this.options.randomErrorProbability) {
                const { newState, error } = this.generateNewError();
                this.state = newState;
                debug('new error generated, length: ', error, newState.phase === 'error' ? newState.time : 'single');
                return error;
            }
            return false;
        }
        const { newState, error } = this.continueCurrentError();
        this.state = newState;
        if (error !== false) {
            debug('current error remain active', error);
        }
        return error;
    }
    continueCurrentError() {
        if (this.state.phase === 'no-error') {
            return {
                error: false,
                newState: this.noErrorState()
            };
        }
        const diffMs = new Date().getTime() - this.state.time.startedAt.getTime();
        if (diffMs >= this.state.time.lengthMs) {
            return {
                error: false,
                newState: this.noErrorState()
            };
        }
        return {
            error: this.state.currentError,
            newState: this.state
        };
    }
    generateNewError() {
        const errorIndex = this.randomInt(0, this.errors.length - 1);
        const error = this.errors[errorIndex];
        if (this.options.randomErrorLengthMs === false) {
            return {
                newState: this.noErrorState(),
                error: error
            };
        }
        const { min, max } = this.options.randomErrorLengthMs;
        const errorTimeMs = this.randomInt(min, max);
        return {
            newState: { phase: 'error',
                currentError: error,
                time: { lengthMs: errorTimeMs, startedAt: new Date() } },
            error: error
        };
    }
    noErrorState() {
        return { phase: 'no-error' };
    }
    randomInt(min, max) {
        return Math.floor(this.random(min, max));
    }
    random(min, max) {
        return Math.random() * (max - min) + min;
    }
}
exports.RandomErrorGenerator = RandomErrorGenerator;
//# sourceMappingURL=random-error-generator.js.map